const routes = [
  {
    path: '/jinjiang/1',
    name: 'jinjiang1',
    meta: {
      title: '博士后出站后留锦江工作奖励'
    },
    component: () => import('./1.vue')
  },
  {
    path: '/jinjiang/2',
    name: 'jinjiang2',
    meta: {
      title: '博士后设站资助'
    },
    component: () => import('./2.vue')
  },
  {
    path: '/jinjiang/3',
    name: 'jinjiang3',
    meta: {
      title: '成都市锦江区社会力量协同招才引智奖励政策'
    },
    component: () => import('./3.vue')
  },
  {
    path: '/jinjiang/4',
    name: 'jinjiang4',
    meta: {
      title: '高级专业技术人才生活补贴'
    },
    component: () => import('./4.vue')
  },
  {
    path: '/jinjiang/5',
    name: 'jinjiang5',
    meta: {
      title: '高级专业技术人才职称提升奖励'
    },
    component: () => import('./5.vue')
  },
  {
    path: '/jinjiang/6',
    name: 'jinjiang6',
    meta: {
      title: '关于支持高能级科创平台建设'
    },
    component: () => import('./6.vue')
  },
  {
    path: '/jinjiang/7',
    name: 'jinjiang7',
    meta: {
      title: '关于经营管理领军人才、企业头部人才及新引进高端人才专项奖励'
    },
    component: () => import('./7.vue')
  },
  {
    path: '/jinjiang/8',
    name: 'jinjiang8',
    meta: {
      title: '关于区直属公办中小学（幼儿园）新引进教育人才安家补贴'
    },
    component: () => import('./8.vue')
  },
  {
    path: '/jinjiang/9',
    name: 'jinjiang9',
    meta: {
      title: '锦江区关于人才提能争优奖励'
    },
    component: () => import('./9.vue')
  },
  {
    path: '/jinjiang/10',
    name: 'jinjiang10',
    meta: {
      title: '锦江区关于支持锦江软件园引进急需紧缺人才'
    },
    component: () => import('./10.vue')
  },
  {
    path: '/jinjiang/11',
    name: 'jinjiang11',
    meta: {
      title: '支持科技成果转移转化奖励'
    },
    component: () => import('./11.vue')
  },
  {
    path: '/jinjiang/12',
    name: 'jinjiang12',
    meta: {
      title: '关于支持青年创业平台建设'
    },
    component: () => import('./12.vue')
  },
  {
    path: '/jinjiang/13',
    name: 'jinjiang13',
    meta: {
      title: '锦江区关于支持青年人才创新创业'
    },
    component: () => import('./13.vue')
  },
  {
    path: '/jinjiang/14',
    name: 'jinjiang14',
    meta: {
      title: '锦江区关于支持引进培养高技能人才政策解读'
    },
    component: () => import('./14.vue')
  },
  {
    path: '/jinjiang/15',
    name: 'jinjiang15',
    meta: {
      title: '企业购买人力资源服务补贴'
    },
    component: () => import('./15.vue')
  },
  {
    path: '/jinjiang/16',
    name: 'jinjiang16',
    meta: {
      title: '全日制应届研究生生活补贴'
    },
    component: () => import('./16.vue')
  },
  {
    path: '/jinjiang/17',
    name: 'jinjiang17',
    meta: {
      title: '卫生人才奖励补贴'
    },
    component: () => import('./17.vue')
  },
]

export default routes